module.exports = __webpack_public_path__ + "static/img/h-winicon.637f0342.webp";